import { useId } from 'react'

export const useViewTransitionName = (prefix = 'ds') => {
    const id = useId()

    return `${prefix}${id.replaceAll(':', '_')}`
}
